import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Flex,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  Image,
  Button,
  Input,
} from "@chakra-ui/react";
import CloseIconBlack from "../../../assets/images/product/closeIconBlack.svg";
import {
  InputControl,
  InputDatePicker,
  SelectControl,
} from "../../../components/form/formControls";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import useDebounce from "../../../hooks/useDebounce";
import { useConditionalLists } from "../../../hooks/useCustomer";
import SearchBox from "../searchBox";
import SearchCheckBox from "../searchCheckBox";
import { DataPlaceOfIdentification } from "../../../utils/globalVariable";
import { provinceCall } from "../../../api/province";
import { districtCall } from "../../../api/district";
import { wardCall } from "../../../api/ward";
import { commonCall } from "../../../api/common";
import toast from "react-hot-toast";
import imageIcon from "../../../assets/images/booking/image.svg";

const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const schema = Yup.object().shape({
  name: Yup.string().required("Vui lòng nhập tên doanh nghiệp"),
  phone: Yup.string()
    .transform((value) => (value?.trim() === "" ? null : value))
    .nullable()
    .matches(/^[0-9]+$/, "Số điện thoại không hợp lệ"),
  email: Yup.string().optional().nullable().email("Email không hợp lệ"),
  // customerTypeId: Yup.string().required("Vui lòng nhóm khách hàng"),
  // wishlist: Yup.array()
  //   .transform((value, originalValue) =>
  //     typeof originalValue === "string" && originalValue.trim() === ""
  //       ? []
  //       : value
  //   )
  //   .min(1, "Vui lòng chọn ít nhất một dự án quan tâm")
  //   .required("Vui lòng dự án quan tâm"),
  // businessTaxCode: Yup.string().required(
  //   "Vui lòng nhập mã số thuế doanh nghiệp"
  // ),
  // businessRegistrationPlace: Yup.string().required(
  //   "Vui lòng nhập nơi cấp đăng ký kinh doanh"
  // ),
  // representativeName: Yup.string().required(
  //   "Vui lòng nhập tên người đại diện trên đăng ký kinh doanh hoặc người ký HĐMB"
  // ),
  representativeIdNumber: Yup.string()
    .transform((value) => (value?.trim() === "" ? null : value))
    .nullable()
    .matches(/^\d{9}$|^\d{12}$/, "Số CCCD/CMND không hợp lệ (9 hoặc 12 số)."),
  // .matches(/^\d{9}$|^\d{12}$/, "Số CCCD/CMND không hợp lệ(9 hoặc 12 số).")
  // .required("Vui lòng nhập số CCCD/CMND của người đại diện"),
  // representativeIdIssuedDate: Yup.string().required(
  //   "Vui lòng nhập ngày cấp CCCD/CMND của người đại diện"
  // ),
  // representativeIdIssuedPlace: Yup.string().required(
  //   "Vui lòng nhập nơi cấp CCCD/CMND của người đại diện"
  // ),
  // representativePosition: Yup.string().required(
  //   "Vui lòng nhập chức vụ người đại diện"
  // ),
  // employeeId: Yup.string().required("Vui lòng chọn nhân viên tạo"),
  // gender: Yup.number()
  //   .transform((value, originalValue) => {
  //     return originalValue === "" ? undefined : Number(originalValue);
  //   })
  //   .oneOf([1, 2, 3], "Giới tính không hợp lệ")
  //   .required("Giới tính người đại diện là bắt buộc"),
  // idRepresentativeCardFrontImage: Yup.string().required(
  //   "Ảnh CCCD mặt trước là bắt buộc"
  // ),
  // idRepresentativeCardBackImage: Yup.string().required(
  //   "Ảnh CCCD mặt sau là bắt buộc"
  // ),
  // businessRegistrationImage: Yup.array()
  //   .of(
  //     Yup.object({
  //       id: Yup.mixed().required(),
  //       status: Yup.boolean().required(),
  //     })
  //   )
  //   .test(
  //     "check-empty",
  //     "Vui lòng chọn ảnh đăng ký kinh doanh doanh nghiệp",
  //     (value) => {
  //       return Array.isArray(value) && value.length > 0;
  //     }
  //   )
  //   .test(
  //     "check-status",
  //     "Vui lòng chọn ảnh đăng ký kinh doanh doanh nghiệp",
  //     (value) => {
  //       if (!Array.isArray(value) || value.length === 0) return true;
  //       return value.every((img) => img.status === true);
  //     }
  //   ),
  // bankName: Yup.string().required("Vui lòng nhập tên ngân hàng"),
  // nameAccount: Yup.string().required("Vui lòng nhập tên tài khoản"),
  // bankAccount: Yup.string().matches(
  //   /^[0-9]+$/,
  //   "Số tài khoản ngân hàng không hợp lệ"
  // ),
  // businessAddress: Yup.string().required(
  //   "Địa chỉ trên đăng ký kinh doanh là bắt buộc"
  // ),
  // businessLocationAddress: Yup.string().required(
  //   "Địa chỉ văn phòng doanh nghiệp là bắt buộc"
  // ),
  // businessRegistrationDate: Yup.string().required(
  //   "Ngày cấp đăng ký kinh doanh là bắt buộc"
  // ),
  representativeVnidImage: Yup.string().required("Ảnh VNID là bắt buộc"),
});

const FormNewBusiness = ({
  isOpen,
  onClose,
  defaultValues,
  onSubmit,
  isEdit = false,
}) => {
  const {
    register,
    getValues,
    handleSubmit,
    setValue,
    watch,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValues || {},
  });
  const [inputColors, setInputColors] = useState({
    dateOfIdentification: "var(--color-text-unclick)",
  });
  const [focusStates, setFocusStates] = useState({});
  const [permanentAddressProvince, setPermanentAddressProvince] =
    useState(null);
  const [permanentAddressDistrict, setPermanentAddressDistrict] =
    useState(null);
  const [permanentAddressWard, setPermanentAddressWard] = useState(null);
  const [currentAddressProvince, setCurrentAddressProvince] = useState(null);
  const [currentAddressDistrict, setCurrentAddressDistrict] = useState(null);
  const [currentAddressWard, setCurrentAddressWard] = useState(null);

  const [businessRegistrationImage, setBusinessRegistrationImage] = useState(
    []
  );
  const [businessRegistrationImageError, setBusinessRegistrationImageError] =
    useState(false);
  const imageRefs = useRef([]);

  const watchPermanentAddressProvince = watch("permanentAddressProvince");
  const watchPermanentAddressDistrict = watch("permanentAddressDistrict");
  const watchCurrentAddressProvince = watch("currentAddressProvince");
  const watchCurrentAddressDistrict = watch("currentAddressDistrict");

  const [isLoadingUpload, setIsloadingUpload] = useState(false);
  const [idRepresentativeCardFrontImage, setIdRepresentativeCardFrontImage] =
    useState(null);
  const [idRepresentativeCardBackImage, setIdRepresentativeCardBackImage] =
    useState(null);
  const [representativeVnidImage, setRepresentativeVnidImage] =
    useState(null);

  const genders = [
    {
      value: 1,
      label: "Nam",
    },
    {
      value: 2,
      label: "Nữ",
    },
    {
      value: 3,
      label: "Khác",
    },
  ];

  useEffect(() => {
    if (isOpen) {
      reset(defaultValues);
      setInputColors({
        dateOfIdentification: "var(--text-gray-form)",
      });
    }

    setBusinessRegistrationImage([]);

    if (defaultValues?.businessRegistrationImage?.length) {
      const initImages = defaultValues.businessRegistrationImage.map(
        (path, idx) => ({
          id: Date.now() + idx,
          path,
          imageUrl: null,
          file: null,
          status: true, // ảnh đã upload
        })
      );
      setBusinessRegistrationImage(initImages);
    }

    if (!isEdit) {
      setValue("jobId", "");
      setValue("customerTypeId", "");
      setValue("wishlist", "");
      setValue("bankAccount", "");
      setValue("bankName", "");
      setValue("nameAccount", "");
    }

    if (defaultValues?.permanentAddressProvince) {
      setValue(
        "permanentAddressProvince",
        defaultValues?.permanentAddressProvince.toString()
      );
    }

    if (defaultValues?.permanentAddressDistrict) {
      setValue(
        "permanentAddressDistrict",
        defaultValues?.permanentAddressDistrict.toString()
      );
    }

    if (defaultValues?.permanentAddressWard) {
      setValue(
        "permanentAddressWard",
        defaultValues?.permanentAddressWard.toString()
      );
    }

    if (defaultValues?.currentAddressProvince) {
      setValue(
        "currentAddressProvince",
        defaultValues?.currentAddressProvince.toString()
      );
    }

    if (defaultValues?.currentAddressDistrict) {
      setValue(
        "currentAddressDistrict",
        defaultValues?.currentAddressDistrict.toString()
      );
    }

    if (defaultValues?.currentAddressWard) {
      setValue(
        "currentAddressWard",
        defaultValues?.currentAddressWard.toString()
      );
    }

    if (defaultValues?.idRepresentativeCardFrontImage) {
      setIdRepresentativeCardFrontImage((prev) => ({
        ...prev,
        path: defaultValues?.idRepresentativeCardFrontImage,
        id: 1,
        status: true,
        init: true,
      }));
    }

    if (defaultValues?.idRepresentativeCardBackImage) {
      setIdRepresentativeCardBackImage((prev) => ({
        ...prev,
        path: defaultValues?.idRepresentativeCardBackImage,
        id: 2,
        status: true,
        init: true,
      }));
    }

    if (defaultValues?.representativeVnidImage) {
      setRepresentativeVnidImage((prev) => ({
        ...prev,
        path: defaultValues?.representativeVnidImage,
        id: 2,
        status: true,
        init: true,
      }));
    }
  }, [isOpen, defaultValues, reset]);

  useEffect(() => {
    setValue("businessRegistrationImage", businessRegistrationImage);
    if (
      businessRegistrationImage?.length > 0 &&
      businessRegistrationImage?.filter((img) => img.status === false)
    ) {
      setBusinessRegistrationImageError(true);
    } else {
      setBusinessRegistrationImageError(false);
    }
  }, [businessRegistrationImage, setValue]);

  const formatEntriesForSelectProvince = (entries) =>
    Array.isArray(entries)
      ? entries.map(({ code, name }) => ({
          value: code,
          label: name,
        }))
      : Object.entries(entries || {}).map(([code, name]) => ({
          value: code,
          label: name,
        }));

  // tìm tỉnh ban đầu
  useEffect(() => {
    const getProvince = async () => {
      const data = await provinceCall.list({ search: "" });
      // console.log(data);
      if (data.items) {
        const options = formatEntriesForSelectProvince(data.items);
        setPermanentAddressProvince(options);
        setCurrentAddressProvince(options);
      }
    };
    getProvince();
  }, []);

  // tìm huyện xã phường Địa chỉ thường trú
  useEffect(() => {
    if (watchPermanentAddressDistrict) {
      const getWard = async () => {
        const data = await wardCall.list({
          search: "",
          district_code: watchPermanentAddressDistrict,
        });
        if (data.items) {
          const options = formatEntriesForSelectProvince(data.items);
          setPermanentAddressWard(options);
        }
      };
      getWard();
    }
  }, [watchPermanentAddressDistrict]);

  useEffect(() => {
    if (watchPermanentAddressProvince) {
      const getDistrict = async () => {
        const data = await districtCall.list({
          search: "",
          province_code: watchPermanentAddressProvince,
        });
        if (data.items) {
          const options = formatEntriesForSelectProvince(data.items);
          setPermanentAddressDistrict(options);
        }
      };
      getDistrict();
    }
  }, [watchPermanentAddressProvince]);

  // tìm huyện xã phường Chỗ ở hiện tại
  useEffect(() => {
    if (watchCurrentAddressProvince) {
      const getDistrict = async () => {
        const data = await districtCall.list({
          search: "",
          province_code: watchCurrentAddressProvince,
        });
        if (data.items) {
          const options = formatEntriesForSelectProvince(data.items);
          setCurrentAddressDistrict(options);
        }
      };
      getDistrict();
    }
  }, [watchCurrentAddressProvince]);

  useEffect(() => {
    if (watchCurrentAddressDistrict) {
      const getWard = async () => {
        const data = await wardCall.list({
          search: "",
          district_code: watchCurrentAddressDistrict,
        });
        if (data.items) {
          const options = formatEntriesForSelectProvince(data.items);
          setCurrentAddressWard(options);
        }
      };
      getWard();
    }
  }, [watchCurrentAddressDistrict]);

  const handleFocus = (field) => {
    setFocusStates((prev) => ({ ...prev, [field]: true }));
  };

  const handleBlur = (field) => {
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };

  //ảnh đăng ký kinh doanh của doanh nghiệp
  // Chọn ảnh là tự upload (selectedFile), nút "Tải lại" chỉ dùng khi upload lỗi
  const handleUploadDelegationImage = async (index, selectedFile) => {
    const file = selectedFile || businessRegistrationImage[index]?.file;
    if (!file) return;

    // Tìm ảnh theo file vì trong lúc upload có thể đã xoá ô khác hoặc chọn ảnh khác
    const updateImage = (data) =>
      setBusinessRegistrationImage((prev) => {
        const position = prev.findIndex((item) => item?.file === file);
        if (position < 0) return prev;
        const updated = [...prev];
        updated[position] = { ...updated[position], ...data };
        return updated;
      });

    updateImage({ uploading: true });

    try {
      const { filePath } = await commonCall.uploadFile(
        file,
        "salesContractImage"
      );

      if (filePath) {
        updateImage({ path: filePath, status: true, uploading: false });
        toast.success("Upload ảnh thành công");
        clearErrors("businessRegistrationImage");
      } else {
        updateImage({ uploading: false });
        toast.error("Upload thất bại");
      }
    } catch (error) {
      // commonCall.uploadFile đã báo lỗi bằng toast
      updateImage({ uploading: false });
    }
  };

  const handleAddDelegationImage = () => {
    setBusinessRegistrationImage((prev) => {
      const newImage = {
        id: Date.now(),
        path: null,
        imageUrl: null,
        file: null,
        status: false,
      };

      setTimeout(() => {
        const index = prev?.length; // index mới
        imageRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 100); // để DOM cập nhật xong mới scroll

      return [...prev, newImage];
    });
  };

  const handleChangeDelegationImage = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const imageUrl = URL.createObjectURL(file);
    const updated = [...businessRegistrationImage];
    updated[index] = {
      ...updated[index],
      file,
      imageUrl,
      status: false,
      path: null,
    };
    setBusinessRegistrationImage(updated);
    handleUploadDelegationImage(index, file);
  };

  const handleRemoveDelegationImage = (index) => {
    const updated = [...businessRegistrationImage];
    updated.splice(index, 1);
    setBusinessRegistrationImage(updated);
    if (businessRegistrationImage?.length === 0) {
      setBusinessRegistrationImageError(false);
    }
  };
  // kết thúc ảnh đăng ký kinh doanh của doanh nghiệp

  const handleDateChange = (selectedDate, inputName) => {
    setValue(inputName, selectedDate, { shouldValidate: true });
    // const selectedDate = e.target.value;
    // setInputColors((prevColors) => ({
    //   ...prevColors,
    //   [inputName]: selectedDate
    //     ? "var(--color-info-employee)"
    //     : "var(--color-text-unclick)",
    // }));
  };

  const onchangeCareer = (option) => {
    setValue("jobId", option);
  };

  const onchangeType = (option) => {
    setValue("customerTypeId", option);
  };

  const onchangeProject = (option) => {
    setValue("wishlist", option);
  };

  const onchangeEmpoyeeList = (option) => {
    setValue("employeeId", option);
  };

  const submitHandler = (data) => {
    if (businessRegistrationImage?.length > 0) {
      data.businessRegistrationImage = businessRegistrationImage
        .filter((img) => img?.path)
        .map((img) => img.path);
    } else {
      data.businessRegistrationImage = [];
    }

    onSubmit(data);
    // console.log(data);
  };

  const onchangeGender = (option) => {
    setValue("gender", option);
  };

  const [searchTermJob, setSearchTermJob] = useState("");
  const debouncedSearchTermJob = useDebounce(searchTermJob, 500);

  const [searchTermCustomerType, setSearchTermCustomerType] = useState("");
  const debouncedSearchTermCustomerType = useDebounce(
    searchTermCustomerType,
    500
  );

  const [searchTermProject, setSearchTermProject] = useState("");
  const debouncedSearchTermProject = useDebounce(searchTermProject, 500);

  const { jobList, isLoading: jobIsLoading } = useConditionalLists(
    debouncedSearchTermJob,
    { job: true }
  );
  const { customerTypeList, isLoading: customerTypeIsLoading } =
    useConditionalLists(debouncedSearchTermCustomerType, {
      customerType: true,
    });
  const { projectList, isLoading: projectIsLoading } = useConditionalLists(
    debouncedSearchTermProject,
    { project: true }
  );
  const { employeeList } = useConditionalLists(debouncedSearchTermJob, {
    employee: true,
  });

  const formatEntriesForSelect = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({
      value: key,
      label: value,
    }));
  const jobs = useMemo(() => {
    if (!jobList) return [];
    return formatEntriesForSelect(jobList);
  }, [jobList]);
  const customerTypes = useMemo(() => {
    if (!customerTypeList) return [];
    return formatEntriesForSelect(customerTypeList);
  }, [customerTypeList]);
  const projects = useMemo(() => {
    if (!projectList) return [];
    return formatEntriesForSelect(projectList);
  }, [projectList]);
  const employees = useMemo(
    () => formatEntriesForSelect(employeeList),
    [employeeList]
  );

  const initJob = jobs?.find((type) => type.value === watch("jobId"));
  const initType = customerTypes?.find(
    (job) => job.value === watch("customerTypeId")
  );
  const initProject = customerTypes?.filter(
    (job) => job.value === watch("wishlist")
  );

  const onchangePermanentAddressProvince = (option) => {
    // clearErrors("saleBlockId");
    setValue("permanentAddressProvince", option);
    setValue("permanentAddressDistrict", "");
    setValue("permanentAddressWard", "");
    setPermanentAddressDistrict(null);
    setPermanentAddressWard(null);
  };

  const onchangePermanentAddressDistrict = (option) => {
    // clearErrors("saleBlockId");
    setValue("permanentAddressDistrict", option);
    setValue("permanentAddressWard", "");
    setPermanentAddressWard(null);
  };

  const onchangePermanentAddressWard = (option) => {
    // clearErrors("saleBlockId");
    setValue("permanentAddressWard", option);
  };

  const onchangeCurrentAddressProvince = (option) => {
    // clearErrors("saleBlockId");
    setValue("currentAddressProvince", option);
    setValue("currentAddressDistrict", "");
    setValue("currentAddressWard", "");
    setCurrentAddressDistrict(null);
    setCurrentAddressWard(null);
  };

  const onchangeCurrentAddressDistrict = (option) => {
    // clearErrors("saleBlockId");
    setValue("currentAddressDistrict", option);
    setValue("currentAddressWard", "");
    setCurrentAddressWard(null);
  };

  const onchangeCurrentAddressWard = (option) => {
    // clearErrors("saleBlockId");
    setValue("currentAddressWard", option);
  };

  const uploadIdCardFrontImage = async (file) => {
    setIsloadingUpload(true);
    try {
      if (file) {
        const { filePath } = await commonCall.uploadFile(
          file,
          "salesContractImage"
        );

        if (filePath) {
          setIdRepresentativeCardFrontImage({
            path: filePath,
            id: Date.now(),
            status: true,
            init: false,
          });
          clearErrors("idRepresentativeCardFrontImage");
          setValue("idRepresentativeCardFrontImage", filePath);
          toast.success("Upload ảnh thành công");
        } else {
          toast.error("Có lỗi xảy ra khi upload ảnh");
        }
      }
    } catch (error) {
      // commonCall.uploadFile đã báo lỗi bằng toast, bấm Tải lại để thử lại
      console.error(error);
    } finally {
      setIsloadingUpload(false);
    }
  };

  const changeIdCardFrontImage = (event, type, id) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      const imageUrl = URL.createObjectURL(file);

      reader.onload = (e) => {
        setIdRepresentativeCardFrontImage((prev) => ({
          ...prev,
          id: id || Date.now(),
          imageUrl: imageUrl,
          file: file,
          status: false,
        }));
        clearErrors("idRepresentativeCardFrontImage");
        // Chọn ảnh là tự upload, không cần bấm nút
        uploadIdCardFrontImage(file);
      };

      reader.readAsDataURL(file);
    }
  };

  const uploadIdCardBackImage = async (file) => {
    setIsloadingUpload(true);
    try {
      if (file) {
        const { filePath } = await commonCall.uploadFile(
          file,
          "salesContractImage"
        );

        if (filePath) {
          setIdRepresentativeCardBackImage({
            path: filePath,
            id: Date.now(),
            status: true,
            init: false,
          });
          clearErrors("idRepresentativeCardBackImage");
          setValue("idRepresentativeCardBackImage", filePath);
          toast.success("Upload ảnh thành công");
        } else {
          toast.error("Có lỗi xảy ra khi upload ảnh");
        }
      }
    } catch (error) {
      // commonCall.uploadFile đã báo lỗi bằng toast, bấm Tải lại để thử lại
      console.error(error);
    } finally {
      setIsloadingUpload(false);
    }
  };

  const changeIdCardBackImage = (event, type, id) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      const imageUrl = URL.createObjectURL(file);

      reader.onload = (e) => {
        setIdRepresentativeCardBackImage((prev) => ({
          ...prev,
          id: id || Date.now(),
          imageUrl: imageUrl,
          file: file,
          status: false,
        }));
        clearErrors("idRepresentativeCardBackImage");
        // Chọn ảnh là tự upload, không cần bấm nút
        uploadIdCardBackImage(file);
      };

      reader.readAsDataURL(file);
    }
  };

  const uploadRepresentativeVnidImage = async (file) => {
    setIsloadingUpload(true);
    try {
      if (file) {
        const { filePath } = await commonCall.uploadFile(
          file,
          "salesContractImage"
        );

        if (filePath) {
          setRepresentativeVnidImage({
            path: filePath,
            id: Date.now(),
            status: true,
            init: false,
          });
          clearErrors("representativeVnidImage");
          setValue("representativeVnidImage", filePath);
          toast.success("Upload ảnh thành công");
        } else {
          toast.error("Có lỗi xảy ra khi upload ảnh");
        }
      }
    } catch (error) {
      // commonCall.uploadFile đã báo lỗi bằng toast, bấm Tải lại để thử lại
      console.error(error);
    } finally {
      setIsloadingUpload(false);
    }
  };

  const changeRepresentativeVnidImage = (event, type, id) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      const imageUrl = URL.createObjectURL(file);

      reader.onload = (e) => {
        setRepresentativeVnidImage((prev) => ({
          ...prev,
          id: id || Date.now(),
          imageUrl: imageUrl,
          file: file,
          status: false,
        }));
        clearErrors("representativeVnidImage");
        // Chọn ảnh là tự upload, không cần bấm nút
        uploadRepresentativeVnidImage(file);
      };

      reader.readAsDataURL(file);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        w={"100%"}
        maxW={"625px"}
        overflowY={"auto"}
        sx={{
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            width: "4px",
            borderRadius: "50px",
            background: "var(--color-background)",
          },
          "&::-moz-scrollbar": {
            width: "4px",
          },
          "&::-moz-scrollbar-thumb": {
            width: "4px",
            borderRadius: "50px",
            background: "var(--color-background)",
          },
        }}
      >
        <form onSubmit={handleSubmit(submitHandler)}>
          <Flex minH={"625px"} flexDirection={"column"}>
            <Flex
              justifyContent={"space-between"}
              alignItems={"center"}
              gap={"10px"}
              padding={"25px 24px"}
              borderBottom={"1px solid var(--bg-line-employee)"}
            >
              <Text
                color="var(--color-header-employee)"
                fontSize={"18px"}
                fontWeight={"600"}
              >
                {isEdit ? "Chỉnh sửa khách hàng" : "Khách hàng mới"}
              </Text>
              <Box cursor={"pointer"} onClick={onClose}>
                <Image src={CloseIconBlack} />
              </Box>
            </Flex>
            <Box flex={1} w={"545px"} m={"24px auto"}>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  label="Tên doanh nghiệp"
                  placeholder="Nhập tên doanh nghiệp"
                  onFocus={() => handleFocus("name")}
                  onBlur={() => handleBlur("name")}
                  state={focusStates["name"]}
                  register={register("name")}
                  errors={errors.name}
                  isRequired={true}
                  isUppercase={true}
                />
                <InputControl
                  label="Mã số thuế"
                  placeholder="Nhập mã số thuế"
                  errors={errors.businessTaxCode}
                  onFocus={() => handleFocus("businessTaxCode")}
                  onBlur={() => handleBlur("businessTaxCode")}
                  state={focusStates["businessTaxCode"]}
                  register={register("businessTaxCode")}
                  mwidth={"100%"}
                  // isRequired={true}
                />
              </Flex>

              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputDatePicker
                  label={"Ngày cấp đăng ký kinh doanh"}
                  focusStates={focusStates["businessRegistrationDate"]}
                  selected={watch("businessRegistrationDate")}
                  onFocus={() => handleFocus("businessRegistrationDate")}
                  onBlur={() => handleBlur("businessRegistrationDate")}
                  onChange={(date) =>
                    handleDateChange(date, "businessRegistrationDate")
                  }
                  dateFormat="dd/MM/yyyy"
                  locale="vi"
                  placeholderText="dd/mm/yy"
                  errors={errors?.businessRegistrationDate}
                  formControlStyle={{
                    maxW: "259px",
                  }}
                  formLabelStyle={{
                    fontWeight: 400,
                    lineHeight: "15px",
                    fontSize: "12px",
                    mb: "6px",
                  }}
                  zIndex={3}
                  // isRequired={true}
                />
                <InputControl
                  label="Địa chỉ trên đăng ký kinh doanh"
                  placeholder="Nhập địa chỉ trên đăng ký kinh doanh"
                  errors={errors.businessAddress}
                  onFocus={() => handleFocus("businessAddress")}
                  onBlur={() => handleBlur("businessAddress")}
                  state={focusStates["businessAddress"]}
                  register={register("businessAddress")}
                  mwidth={"100%"}
                  // isRequired={true}
                />
              </Flex>

              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  label="Địa chỉ văn phòng doanh nghiệp"
                  placeholder="Nhập địa chỉ văn phòng doanh nghiệp"
                  errors={errors.businessLocationAddress}
                  onFocus={() => handleFocus("businessLocationAddress")}
                  onBlur={() => handleBlur("businessLocationAddress")}
                  state={focusStates["businessLocationAddress"]}
                  register={register("businessLocationAddress")}
                  mwidth={"100%"}
                  // isRequired={true}
                />
                <InputControl
                  label="Nơi đăng ký kinh doanh"
                  placeholder="Nhập nơi đăng ký kinh doanh"
                  errors={errors.businessRegistrationPlace}
                  onFocus={() => handleFocus("businessRegistrationPlace")}
                  onBlur={() => handleBlur("businessRegistrationPlace")}
                  state={focusStates["businessRegistrationPlace"]}
                  register={register("businessRegistrationPlace")}
                  mwidth={"100%"}
                  // isRequired={true}
                />
              </Flex>

              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                {/* Ảnh đăng ký kinh doanh */}
                <Box flex={1}>
                  <Box>
                    <Flex justify="space-between" align="center" mb={2}>
                      <Flex alignItems="center" gap="4px">
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Ảnh đăng ký kinh doanh của doanh nghiệp
                        </Text>
                        {/* <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                        >
                          *
                        </Text> */}
                      </Flex>
                      <Button size="sm" onClick={handleAddDelegationImage}>
                        + Thêm ảnh
                      </Button>
                    </Flex>

                    {businessRegistrationImage.map((img, index) => (
                      <Box
                        key={img.id || index}
                        mb={4}
                        ref={(el) => (imageRefs.current[index] = el)}
                      >
                        <Flex
                          border="1px solid #ccc"
                          borderRadius="8px"
                          p={2}
                          align="center"
                          gap={4}
                          position={"relative"}
                          justifyContent={"center"}
                        >
                          <Box w="100%" h="200px" position="relative">
                            {img.imageUrl || img.path ? (
                              <Image
                                src={img.imageUrl || `${baseURL}/${img.path}`}
                                objectFit={"contain"}
                                w="100%"
                                h="100%"
                                borderRadius="8px"
                              />
                            ) : (
                              <Text
                                fontSize="sm"
                                color="gray.400"
                                textAlign="center"
                                mt="80px"
                              >
                                Chưa có ảnh
                              </Text>
                            )}

                            <Input
                              type="file"
                              accept="image/*"
                              opacity={0}
                              position="absolute"
                              top={0}
                              left={0}
                              w="100%"
                              h="100%"
                              cursor="pointer"
                              onChange={(e) =>
                                handleChangeDelegationImage(e, index)
                              }
                            />
                          </Box>

                          <Box
                            position="absolute"
                            top="8px"
                            right="8px"
                            zIndex={2}
                          >
                            <Button
                              size="sm"
                              colorScheme="red"
                              onClick={() => handleRemoveDelegationImage(index)}
                            >
                              Xóa
                            </Button>
                          </Box>
                        </Flex>
                        {!img.imageUrl && !img?.status && (
                          <Text
                            fontSize="12px"
                            color="red"
                            lineHeight={"15px"}
                            mt={"8px"}
                            textAlign={"right"}
                          >
                            Vui lòng chọn ảnh
                          </Text>
                        )}
                        {img.imageUrl && !img.status && (
                          <Text
                            fontSize="12px"
                            color="red"
                            lineHeight={"15px"}
                            mt={"8px"}
                            textAlign={"right"}
                          >
                            {img.uploading
                              ? "Đang tải ảnh lên..."
                              : "Tải ảnh lên thất bại, vui lòng bấm Tải lại"}
                          </Text>
                        )}
                        <Flex w={"full"} justifyContent={"flex-end"} mt={2}>
                          {!img.status && img.file && (
                            <Button
                              bg={"var(--linear-gradient-employee)"}
                              color={"var(--color-main)"}
                              fontSize={"12px"}
                              lineHeight={"17px"}
                              // p={"6px 27px 5px 28px"}
                              fontWeight={"600"}
                              _hover={{
                                filter: "brightness(90%)",
                              }}
                              onClick={() => handleUploadDelegationImage(index)}
                              isDisabled={!img.file}
                              h={"28px"}
                              minH={"28px"}
                              w={"90px"}
                              isLoading={isLoadingUpload || img.uploading}
                            >
                              Tải lại
                            </Button>
                          )}
                        </Flex>
                      </Box>
                    ))}

                    {errors?.businessRegistrationImage?.message &&
                      !businessRegistrationImageError && (
                        <Text fontSize="12px" color="red" lineHeight={"15px"}>
                          {errors?.businessRegistrationImage?.message}
                        </Text>
                      )}
                  </Box>
                </Box>
              </Flex>

              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  type={"number"}
                  label="Số điện thoại doanh nghiệp"
                  placeholder="Nhập số điện thoại doanh nghiệp"
                  register={register("phone")}
                  errors={errors.phone}
                  onFocus={() => handleFocus("phone")}
                  onBlur={() => handleBlur("phone")}
                  state={focusStates["phone"]}
                  // isRequired={true}
                />
                <InputControl
                  type={"email"}
                  label="Email doanh nghiệp"
                  placeholder="Nhập email doanh nghiệp"
                  errors={errors.email}
                  onFocus={() => handleFocus("email")}
                  onBlur={() => handleBlur("email")}
                  register={register("email")}
                  state={focusStates["email"]}
                  // isRequired={true}
                />
              </Flex>

              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  label="Tên người đại diện"
                  placeholder="Nhập tên người đại diện"
                  errors={errors.representativeName}
                  onFocus={() => handleFocus("representativeName")}
                  onBlur={() => handleBlur("representativeName")}
                  state={focusStates["representativeName"]}
                  register={register("representativeName")}
                  mwidth={"100%"}
                  // isRequired={true}
                />
                <SelectControl
                  label="Giới tính người đại diện"
                  dataOption={genders}
                  selectedMain={watch("gender")}
                  placeholder="Chọn giới tính"
                  onChange={onchangeGender}
                  onFocus={() => handleFocus("gender")}
                  onBlur={() => handleBlur("gender")}
                  state={focusStates["gender"]}
                  registerProps={register("gender")}
                  // isRequired={true}
                  errorMessage={errors.gender}
                />
              </Flex>

              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  type={"number"}
                  label="Số CCCD người đại diện"
                  placeholder="Nhập số CCCD"
                  errors={errors.representativeIdNumber}
                  onFocus={() => handleFocus("representativeIdNumber")}
                  onBlur={() => handleBlur("representativeIdNumber")}
                  register={register("representativeIdNumber")}
                  state={focusStates["representativeIdNumber"]}
                  // isRequired={true}
                />
                <InputDatePicker
                  label={"Ngày cấp CCCD người đại diện"}
                  focusStates={focusStates["representativeIdIssuedDate"]}
                  selected={watch("representativeIdIssuedDate")}
                  onFocus={() => handleFocus("representativeIdIssuedDate")}
                  onBlur={() => handleBlur("representativeIdIssuedDate")}
                  onChange={(date) =>
                    handleDateChange(date, "representativeIdIssuedDate")
                  }
                  dateFormat="dd/MM/yyyy"
                  locale="vi"
                  placeholderText="dd/mm/yy"
                  errors={errors?.representativeIdIssuedDate}
                  formControlStyle={{
                    maxW: "259px",
                  }}
                  formLabelStyle={{
                    fontWeight: 400,
                    lineHeight: "15px",
                    fontSize: "12px",
                    mb: "6px",
                  }}
                  zIndex={3}
                  // isRequired={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  label="Nơi cấp CCCD người đại diện"
                  placeholder="Nhập nơi cấp"
                  errors={errors.representativeIdIssuedPlace}
                  onFocus={() => handleFocus("representativeIdIssuedPlace")}
                  onBlur={() => handleBlur("representativeIdIssuedPlace")}
                  register={register("representativeIdIssuedPlace")}
                  onChange={(e) =>
                    setValue("representativeIdIssuedPlace", e.target.value)
                  }
                  data={DataPlaceOfIdentification}
                  state={focusStates["representativeIdIssuedPlace"]}
                  // isRequired={true}
                  mwidth={"100%"}
                />
                <InputControl
                  label="Chức vụ người đại diện"
                  placeholder="Nhập chức vụ người đại diện"
                  errors={errors.representativePosition}
                  onFocus={() => handleFocus("representativePosition")}
                  onBlur={() => handleBlur("representativePosition")}
                  state={focusStates["representativePosition"]}
                  register={register("representativePosition")}
                  mwidth={"100%"}
                  // isRequired={true}
                />
              </Flex>

              {/* Ảnh CCCD mặt trước  */}
              <Box flex={1} mt={"24px"}>
                <Box mt={"16px"}>
                  <Flex>
                    <Box flex={"1"}>
                      <Flex alignItems="center" gap="4px">
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Ảnh CCCD mặt trước
                        </Text>
                        {/* <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                        >
                          *
                        </Text> */}
                      </Flex>
                      <Flex
                        mt={"8px"}
                        border={"0.5px solid var(--bg-line-employee)"}
                        borderRadius={"8px"}
                        justifyContent={"center"}
                        position={"relative"}
                      >
                        <Box
                          overflow={"hidden"}
                          w={"100%"}
                          h={"300px"}
                          display={"block"}
                          borderRadius={"11px"}
                          position={"relative"}
                        >
                          {idRepresentativeCardFrontImage && (
                            <Image
                              src={
                                idRepresentativeCardFrontImage?.imageUrl
                                  ? idRepresentativeCardFrontImage?.imageUrl
                                  : `${baseURL}/${idRepresentativeCardFrontImage?.path}`
                              }
                              objectFit={"contain"}
                              h={"100%"}
                              w={"100%"}
                            />
                          )}
                        </Box>
                        {(idRepresentativeCardFrontImage?.path ||
                          idRepresentativeCardFrontImage?.imageUrl) && (
                          <Flex
                            position={"absolute"}
                            right={"8px"}
                            top={"8px"}
                            cursor={"pointer"}
                          >
                            <Box
                              position="absolute"
                              top="8px"
                              right="8px"
                              zIndex={2}
                            >
                              <Button
                                size="sm"
                                colorScheme="red"
                                onClick={() => {
                                  setIdRepresentativeCardFrontImage(null);
                                  setValue(
                                    "idRepresentativeCardFrontImage",
                                    null
                                  );
                                }}
                                padding={2}
                              >
                                Xóa
                              </Button>
                            </Box>
                          </Flex>
                        )}

                        <Flex
                          position={"absolute"}
                          right={"8px"}
                          bottom={"8px"}
                          cursor={"pointer"}
                        >
                          <Box
                            padding={"8px"}
                            bg={"var(--fill-avatar)"}
                            borderRadius={"50%"}
                            mr={"8px"}
                            position={"relative"}
                          >
                            <Input
                              type="file"
                              accept="image/*"
                              multiple
                              opacity={0}
                              position="absolute"
                              top={0}
                              left={0}
                              width="100%"
                              height="100%"
                              cursor="pointer"
                              onChange={(e) =>
                                changeIdCardFrontImage(
                                  e,
                                  1,
                                  idRepresentativeCardFrontImage?.id
                                )
                              }
                            />
                            <Image
                              src={imageIcon}
                              _hover={{
                                filter: "var(--filter-red)",
                              }}
                            />
                          </Box>
                        </Flex>
                      </Flex>
                      {errors?.idRepresentativeCardFrontImage && (
                        <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                          mt={"8px"}
                        >
                          {errors.idRepresentativeCardFrontImage.message}
                        </Text>
                      )}
                    </Box>
                  </Flex>

                  {idRepresentativeCardFrontImage?.file && (
                    <Flex w={"full"} justifyContent={"flex-end"} mt={2}>
                      <Button
                        bg={"var(--linear-gradient-employee)"}
                        color={"var(--color-main)"}
                        fontSize={"12px"}
                        lineHeight={"17px"}
                        // p={"6px 27px 5px 28px"}
                        fontWeight={"600"}
                        _hover={{
                          filter: "brightness(90%)",
                        }}
                        onClick={() =>
                          uploadIdCardFrontImage(
                            idRepresentativeCardFrontImage?.file
                          )
                        }
                        h={"28px"}
                        minH={"28px"}
                        w={"90px"}
                        isLoading={isLoadingUpload}
                      >
                        Tải lại
                      </Button>
                    </Flex>
                  )}
                </Box>
              </Box>

              {/* Ảnh CCCD mặt sau  */}
              <Box flex={1} mt={"24px"} mb={"24px"}>
                <Box mt={"16px"}>
                  <Flex>
                    <Box flex={"1"}>
                      <Flex alignItems="center" gap="4px">
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Ảnh CCCD mặt sau
                        </Text>
                        {/* <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                        >
                          *
                        </Text> */}
                      </Flex>
                      <Flex
                        mt={"8px"}
                        border={"0.5px solid var(--bg-line-employee)"}
                        borderRadius={"8px"}
                        justifyContent={"center"}
                        position={"relative"}
                      >
                        <Box
                          overflow={"hidden"}
                          w={"100%"}
                          h={"300px"}
                          display={"block"}
                          borderRadius={"11px"}
                          position={"relative"}
                        >
                          {idRepresentativeCardBackImage && (
                            <Image
                              src={
                                idRepresentativeCardBackImage?.imageUrl
                                  ? idRepresentativeCardBackImage?.imageUrl
                                  : `${baseURL}/${idRepresentativeCardBackImage?.path}`
                              }
                              objectFit={"contain"}
                              h={"100%"}
                              w={"100%"}
                            />
                          )}
                        </Box>
                        {(idRepresentativeCardBackImage?.path ||
                          idRepresentativeCardBackImage?.imageUrl) && (
                          <Flex
                            position={"absolute"}
                            right={"8px"}
                            top={"8px"}
                            cursor={"pointer"}
                          >
                            <Box
                              position="absolute"
                              top="8px"
                              right="8px"
                              zIndex={2}
                            >
                              <Button
                                size="sm"
                                colorScheme="red"
                                onClick={() => {
                                  setIdRepresentativeCardBackImage(null);
                                  setValue(
                                    "idRepresentativeCardBackImage",
                                    null
                                  );
                                }}
                                padding={2}
                              >
                                Xóa
                              </Button>
                            </Box>
                          </Flex>
                        )}

                        <Flex
                          position={"absolute"}
                          right={"8px"}
                          bottom={"8px"}
                          cursor={"pointer"}
                        >
                          <Box
                            padding={"8px"}
                            bg={"var(--fill-avatar)"}
                            borderRadius={"50%"}
                            mr={"8px"}
                            position={"relative"}
                          >
                            <Input
                              type="file"
                              accept="image/*"
                              multiple
                              opacity={0}
                              position="absolute"
                              top={0}
                              left={0}
                              width="100%"
                              height="100%"
                              cursor="pointer"
                              onChange={(e) =>
                                changeIdCardBackImage(
                                  e,
                                  2,
                                  idRepresentativeCardBackImage?.id
                                )
                              }
                            />
                            <Image
                              src={imageIcon}
                              _hover={{
                                filter: "var(--filter-red)",
                              }}
                            />
                          </Box>
                        </Flex>
                      </Flex>
                      {errors?.idRepresentativeCardBackImage && (
                        <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                          mt={"8px"}
                        >
                          {errors.idRepresentativeCardBackImage.message}
                        </Text>
                      )}
                    </Box>
                  </Flex>

                  {idRepresentativeCardBackImage?.file && (
                    <Flex w={"full"} justifyContent={"flex-end"} mt={2}>
                      <Button
                        bg={"var(--linear-gradient-employee)"}
                        color={"var(--color-main)"}
                        fontSize={"12px"}
                        lineHeight={"17px"}
                        // p={"6px 27px 5px 28px"}
                        fontWeight={"600"}
                        _hover={{
                          filter: "brightness(90%)",
                        }}
                        onClick={() =>
                          uploadIdCardBackImage(
                            idRepresentativeCardBackImage?.file
                          )
                        }
                        h={"28px"}
                        minH={"28px"}
                        w={"90px"}
                        isLoading={isLoadingUpload}
                      >
                        Tải lại
                      </Button>
                    </Flex>
                  )}
                </Box>
              </Box>

              {/* Ảnh VNID  */}
              <Box flex={1} mt={"24px"} mb={"24px"}>
                <Box mt={"16px"}>
                  <Flex>
                    <Box flex={"1"}>
                      <Flex alignItems="center" gap="4px">
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Ảnh VNID
                        </Text>
                        <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                        >
                          *
                        </Text>
                      </Flex>
                      <Flex
                        mt={"8px"}
                        border={"0.5px solid var(--bg-line-employee)"}
                        borderRadius={"8px"}
                        justifyContent={"center"}
                        position={"relative"}
                      >
                        <Box
                          overflow={"hidden"}
                          w={"100%"}
                          h={"300px"}
                          display={"block"}
                          borderRadius={"11px"}
                          position={"relative"}
                        >
                          {representativeVnidImage && (
                            <Image
                              src={
                                representativeVnidImage?.imageUrl
                                  ? representativeVnidImage?.imageUrl
                                  : `${baseURL}/${representativeVnidImage?.path}`
                              }
                              objectFit={"contain"}
                              h={"100%"}
                              w={"100%"}
                            />
                          )}
                        </Box>
                        {(representativeVnidImage?.path ||
                          representativeVnidImage?.imageUrl) && (
                          <Flex
                            position={"absolute"}
                            right={"8px"}
                            top={"8px"}
                            cursor={"pointer"}
                          >
                            <Box
                              position="absolute"
                              top="8px"
                              right="8px"
                              zIndex={2}
                            >
                              <Button
                                size="sm"
                                colorScheme="red"
                                onClick={() => {
                                  setRepresentativeVnidImage(null);
                                  setValue(
                                    "representativeVnidImage",
                                    null
                                  );
                                }}
                                padding={2}
                              >
                                Xóa
                              </Button>
                            </Box>
                          </Flex>
                        )}

                        <Flex
                          position={"absolute"}
                          right={"8px"}
                          bottom={"8px"}
                          cursor={"pointer"}
                        >
                          <Box
                            padding={"8px"}
                            bg={"var(--fill-avatar)"}
                            borderRadius={"50%"}
                            mr={"8px"}
                            position={"relative"}
                          >
                            <Input
                              type="file"
                              accept="image/*"
                              multiple
                              opacity={0}
                              position="absolute"
                              top={0}
                              left={0}
                              width="100%"
                              height="100%"
                              cursor="pointer"
                              onChange={(e) =>
                                changeRepresentativeVnidImage(
                                  e,
                                  2,
                                  representativeVnidImage?.id
                                )
                              }
                            />
                            <Image
                              src={imageIcon}
                              _hover={{
                                filter: "var(--filter-red)",
                              }}
                            />
                          </Box>
                        </Flex>
                      </Flex>
                      {errors?.representativeVnidImage && (
                        <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                          mt={"8px"}
                        >
                          {errors.representativeVnidImage.message}
                        </Text>
                      )}
                    </Box>
                  </Flex>

                  {representativeVnidImage?.file && (
                    <Flex w={"full"} justifyContent={"flex-end"} mt={2}>
                      <Button
                        bg={"var(--linear-gradient-employee)"}
                        color={"var(--color-main)"}
                        fontSize={"12px"}
                        lineHeight={"17px"}
                        // p={"6px 27px 5px 28px"}
                        fontWeight={"600"}
                        _hover={{
                          filter: "brightness(90%)",
                        }}
                        onClick={() =>
                          uploadRepresentativeVnidImage(
                            representativeVnidImage?.file
                          )
                        }
                        h={"28px"}
                        minH={"28px"}
                        w={"90px"}
                        isLoading={isLoadingUpload}
                      >
                        Tải lại
                      </Button>
                    </Flex>
                  )}
                </Box>
              </Box>

              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <SearchBox
                  label={"Nhóm khách hàng"}
                  isSearchable={true}
                  placeholder="Chọn nhóm khách hàng"
                  selectedMain={watch("customerTypeId")}
                  initialSelectedEmp={initType}
                  onChange={onchangeType}
                  data={customerTypes}
                  isLoading={customerTypeIsLoading}
                  searchTerm={searchTermCustomerType}
                  setSearchTerm={setSearchTermCustomerType}
                  errorMessage={errors.customerTypeId}
                  onFocus={() => handleFocus("customerTypeId")}
                  onBlur={() => handleBlur("customerTypeId")}
                  state={focusStates["customerTypeId"]}
                  // isRequired={true}
                />
                <SearchCheckBox
                  label={"Dự án quan tâm"}
                  isSearchable={true}
                  placeholder="Chọn dự án quan tâm"
                  selectedMain={watch("wishlist")}
                  initialSelectedEmp={initProject}
                  onChange={onchangeProject}
                  data={projects}
                  isLoading={projectIsLoading}
                  searchTerm={searchTermProject}
                  setSearchTerm={setSearchTermProject}
                  errorMessage={errors.wishlist}
                  // isRequired={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  label="Tên ngân hàng của công ty"
                  placeholder="Nhập tên ngân hàng"
                  errors={errors.bankName}
                  onFocus={() => handleFocus("bankName")}
                  onBlur={() => handleBlur("bankName")}
                  state={focusStates["bankName"]}
                  register={register("bankName")}
                  mwidth={"100%"}
                  // isRequired={true}
                />
                <InputControl
                  type="number"
                  label="Số tài khoản công ty"
                  placeholder="Nhập số tài khoản"
                  errors={errors.bankAccount}
                  onFocus={() => handleFocus("bankAccount")}
                  onBlur={() => handleBlur("bankAccount")}
                  state={focusStates["bankAccount"]}
                  register={register("bankAccount")}
                  mwidth={"100%"}
                  // isRequired={true}
                />
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <Box w={"100%"}>
                  <InputControl
                    label="Chủ tài khoản"
                    placeholder="Nhập chủ tài khoản"
                    errors={errors.nameAccount}
                    onFocus={() => handleFocus("nameAccount")}
                    onBlur={() => handleBlur("nameAccount")}
                    state={focusStates["nameAccount"]}
                    register={register("nameAccount")}
                    mwidth={"100%"}
                    // isRequired={true}
                  />
                  <Text
                    lineHeight={"15px"}
                    fontSize={{ base: "12px" }}
                    fontWeight={400}
                    mt={{ base: "4px" }}
                    color={"var(--color-option-employee-hover)"}
                  >
                    ( Bắt buộc là tên công ty )
                  </Text>
                </Box>
              </Flex>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <SelectControl
                  label={"Nhân viên tạo"}
                  dataOption={employees}
                  placeholder="Chọn nhân viên"
                  selectedMain={watch("employeeId")}
                  onChange={onchangeEmpoyeeList}
                  onFocus={() => handleFocus("employeeId")}
                  onBlur={() => handleBlur("employeeId")}
                  state={focusStates["employeeId"]}
                  registerProps={register("employeeId")}
                  errorMessage={errors.employeeId}
                  mwidth="100%"
                  isSearchable={true}
                  // isRequired={true}
                />
              </Flex>
            </Box>
            <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
              {isEdit ? (
                <>
                  <Button
                    onClick={onClose}
                    w={"112px"}
                    h={"44px"}
                    color={"var(--color-option-employee-hover)"}
                    border={"1px solid var(--color-option-employee-hover)"}
                    bg={"var(--color-main)"}
                    _hover={{
                      filter: "brightness(80%)",
                    }}
                  >
                    Hủy
                  </Button>
                  <Button
                    type="submit"
                    w={"112px"}
                    h={"44px"}
                    color={"var(--color-main)"}
                    bg={"var(--color-button)"}
                    _hover={{
                      filter: "brightness(80%)",
                    }}
                  >
                    Lưu
                  </Button>
                </>
              ) : (
                <Button
                  type="submit"
                  w={"164px"}
                  h={"44px"}
                  color={"var(--color-main)"}
                  bg={"var(--color-button)"}
                  _hover={{
                    filter: "brightness(80%)",
                  }}
                >
                  Tạo khách hàng
                </Button>
              )}
            </Flex>
          </Flex>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default FormNewBusiness;
